import { Controller } from "@hotwired/stimulus"
import { hideWhenFramed } from "../lib/hide_when_framed"

// Masque son contenu quand la page est embarquée en iframe (démo du hero).
// En visite directe, le contenu (bandeau jeu responsable) reste affiché.
export default class extends Controller {
  connect() {
    hideWhenFramed(this.element)
  }
}
